// SEC-01: cable URL helpers. The JWT travels as a ?token= query-param because browsers
// cannot set WebSocket request headers; backend connection.rb decodes request.params[:token]
// (strips "Bearer ", revocation-aware). SECURITY: callers must never log the tokenized URL.

// http(s)://host → ws(s)://host/cable
export function buildCableUrl(apiUrl) {
  return apiUrl.replace(/^http/, "ws") + "/cable";
}

// Append the JWT as ?token=<raw>. Strips a leading "Bearer " (connection.rb also strips it;
// we send the raw token for a clean URL) and URL-encodes. Returns url unchanged if no token.
export function appendCableToken(cableUrl, token) {
  if (!token) return cableUrl;
  const raw = String(token).replace(/^Bearer\s+/i, "");
  if (!raw) return cableUrl;
  const sep = cableUrl.includes("?") ? "&" : "?";
  return `${cableUrl}${sep}token=${encodeURIComponent(raw)}`;
}
